export default function IconWatermark({
  children,
  className = "",
  size = { w: 96, h: 96 },
  style = {},
}) {
  return (
    <div
      aria-hidden="true"
      className={[
        "pointer-events-none absolute",
        "right-3 md:right-4 top-1/2 -translate-y-1/2",
        "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100",
        "transition-opacity duration-300 ease-out",
        className,
      ].join(" ")}
      style={{ width: size.w, height: size.h, ...style }}
    >
      {children}
    </div>
  );
}
